class CopyToClipboard extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("click", () => {
      const textToCopy = this.dataset?.contentToCopy;

      if (!textToCopy) {
        return;
      }

      const elementContent = this.innerText;

      window.navigator.clipboard.writeText(textToCopy);

      this.innerText = theme.strings.copied;

      setTimeout(() => {
        this.innerText = elementContent;
      }, 1500);
    });
  }
}

if (!customElements.get("copy-to-clipboard")) {
  customElements.define("copy-to-clipboard", CopyToClipboard);
}
